import { useEffect, useState } from "react"
import Api from "../../api/api"
import imageUtilities from "../../../utilities/imageUtilities"
import arrayUtilities from "../../../utilities/arrayUtilities"
import stringHelpers from "../../../utilities/stringHelpers"
import {toDateString} from "../../../utilities/dateUtilities"
import Enums from "../../../utilities/enum"

const CashlessProviderCodesDisplay = ({ allCodes }) => {
    const codes = stringHelpers.isNullOrEmpty(allCodes)
        ? []
        : allCodes.split(",").map(code => code.trim()).filter(code => code !== "")
    return (
        <div className="d-flex flex-wrap">
            {
                codes.map(
                    (code, index) => <div key={ index } className="mr-2 badge badge-pill badge-light border text-secondary position-relative px-3 py-2 mw-100">
                        <p className="text-secondary font-weight-semi-bold fs--1 m-0 text-left" style={ { whiteSpace: "normal", wordBreak: "break-all" } }>{ code.trim() }</p>
                    </div>
                )
            }
        </div>
    )
}

export const DisplayGeneralDetails = ({ site, tags, allowCancellationOfBreaches, enableAutoAssignUser, autoAssignUsername, organisationId, token }) => {
    const [defaultDebtCollectionProvider, setDefaultDebtCollectionProvider] = useState(null);

    const getDefaultDebtCollectionProvider = () => {
        Api.getDebtCollectionProviders(
            (data) => {
                const defaultProvider = data.find(item => item.isDefault)
                if (defaultProvider !== undefined) {
                    setDefaultDebtCollectionProvider(defaultProvider)
                }
            },
            (error) => {
                console.log(error)
            },
            organisationId,
            token
        )
    };

    useEffect(() => getDefaultDebtCollectionProvider(), [])

    return (
        <div className="card-body bg-light border-top">
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold ">Name</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.name }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Region</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.regionName }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Debt Collection Provider</p>
                </div>
                <div className=" col-md-6 col-12 ">
                    { 
                        !stringHelpers.isNullOrEmpty(site.debtCollectionProviderId) 
                        ? site.debtCollectionProviderName 
                        : defaultDebtCollectionProvider !== null
                            ? <>Default ({defaultDebtCollectionProvider.name})</>
                            : <>None</>
                    }
                </div>
            </div>
            <div className="row mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Tags</p>
                </div>
                <div className="col-md-6 col-12 d-flex align-items-center">
                    {
                        !arrayUtilities.isNullOrEmpty(tags)
                        && tags.map((tag) =>
                            <div
                                key={ tag.id }
                                className="d-flex align-items-center badge badge-pill badge-light text-secondary py-2 px-2 border position-relative mr-2"
                            >
                                <i className="fas fa-circle mr-2 ml-1 mb-0 fs--1" style={ {
                                    color: `#${ tag.colourCode }`
                                } }></i>
                                <p className="m-0 mr-1">{ tag.name }</p>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Site Code</p>
                </div>
                <div className=" col-md-6 col-12">{ site.siteCode }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Permit Prefix</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.permitPrefix }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Contract Expiry</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.contractExpiry !== null && toDateString(site.contractExpiry) }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Allowing cancelling of breaches</p>
                </div>
                <div className=" col-md-6 col-12 pt-1">{ allowCancellationOfBreaches && <i className="fas fa-check text-success"></i> }{ !allowCancellationOfBreaches && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            {
                allowCancellationOfBreaches
                    && <div className="row">
                        <div className=" col-md-3 col-12 ">
                            <p className="font-weight-semi-bold">Maximum Cancellations Per Month</p>
                        </div>
                        <div className=" col-md-6 col-12 ">{ site.maximumCancellationsPerMonth !== null && stringHelpers.formatDecimal(site.maximumCancellationsPerMonth, 0) }</div>
                    </div>
            }
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Auto-assign breaches to a user</p>
                </div>
                <div className=" col-md-6 col-12 pt-1">{ enableAutoAssignUser && <i className="fas fa-check text-success"></i> }{ !enableAutoAssignUser && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            {
                enableAutoAssignUser
                    && <div className="row mb-2">
                        <div className=" col-md-3 col-12 ">
                        </div>
                        <div className=" col-md-6 col-12 ">{ autoAssignUsername }</div>
                    </div>
            }
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Status</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.isActive && <i className="fas fa-check text-success"></i> }{ !site.isActive && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Vehicle Analytics</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.vehicleAnalyticsEnabled && <i className="fas fa-check text-success"></i> }{ !site.vehicleAnalyticsEnabled && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Prevent Duplicate Breaches</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.preventDuplicateBreaches && <i className="fas fa-check text-success"></i> }{ !site.preventDuplicateBreaches && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Address</p>
                </div>
                <div className=" col-md-6 col-12 ">
                    <div>{ site.addressLine1 }</div>
                    <div>{ site.addressLine2 }</div>
                    <div>{ site.addressLine3 }</div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Town or City</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.townOrCity }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Post Code</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.postCode }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Jurisdiction</p>
                </div>
                <div className=" col-md-6 col-12 ">{ Enums.Jurisdiction[site.jurisdiction] }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Payment Provider Site Codes</h6>
            <div className="row mb-3">
                <div className=" col-md-3 col-12">
                    <div className='logo-container logo-container-md'>{ imageUtilities.fetchPaymentProviderLogo(1) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.parkonomySiteCode} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(2) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.ringGoZone} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(7) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.parkBunnyLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(4) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.justParkLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(5) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.tap2ParkLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(6) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.payByPhoneLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(8) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.ipsLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(9) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.conviousLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(10) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.lookingForCarParkLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(11) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.newParkLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(12) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.parksoLocationId} /> }</div>
            </div>
            <div className="row mb-3">
                <div className=" col-md-3 col-12 d-flex">
                    <div className='logo-container'>{ imageUtilities.fetchPaymentProviderLogo(13) }</div>
                </div>
                <div className=" col-md-6 col-12 ">{ <CashlessProviderCodesDisplay allCodes={site.myCarPassLocationId} /> }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">IAS Status</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.iasEnabled && <i className="fas fa-check text-success"></i> }{ !site.iasEnabled && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">IAS/IPC Code</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.iasCode }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">BPA Status</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.bpaEnabled && <i className="fas fa-check text-success"></i> }{ !site.bpaEnabled && <i className="fas fa-times text-danger"></i> }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">BPA Site Code</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.bpaCode }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">POFA Enabled</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.pofaEnabled && <i className="fas fa-check text-success"></i> }{ !site.pofaEnabled && <i className="fas fa-times text-danger"></i> }</div>
            </div>

            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Pay and Display Spaces</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.payAndDisplaySpaces }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Pre-Allocated Spaces</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.preAllocatedSpaces }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Disabled Spaces</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.disabledSpaces }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Permit Spaces</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.permitSpaces }</div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold">Other Spaces</p>
                </div>
                <div className=" col-md-6 col-12 ">{ site.otherSpaces }</div>
            </div>
        </div>
    )
}